import React, { useState, useEffect, useContext } from "react";
import { Modal } from "react-bootstrap";
import searchStructure from "./SearchHelper";
import { Link, useHistory, Redirect } from "react-router-dom";
import StarekContext from "../../context/StarekContext";
import { Search } from "../../services/RepositoryService";
import Spinner from "../../components/Spinner";

function SearchModal({
    visibility,
    setVisibility,
    initialSearchText,
    setInitialSearchText,
}) {
    const context = useContext(StarekContext);
    const [searchResults, setSearchResults] = useState([]);
    const [localSearchResults, setLocalSearchResults] = useState([]);
    const [loadingPrimary, setLoadingPrimary] = useState(true);
    const [searchErrorMessage, setSearchErrorMessage] = useState("");
    const [searchMessage, setSearchMessage] = useState(
        "Please enter text in search field."
    );

    useEffect(() => {
        if (!visibility) return;
        triggerSearch();
    }, [visibility]);

    useEffect(() => {
        setInitialSearchText(initialSearchText);
    }, [initialSearchText]);

    const handleInputChange = (e) => {
        const inputValue = e.target.value;
        setInitialSearchText(inputValue);
        setSearchErrorMessage("");
    };

    const handleKeyUp = (e) => {
        const code = e.which;
        //enter
        if (code === 13) triggerSearch();
        //escape
        else if (code === 27) closeModal();
    };

    const closeModal = () => {
        setVisibility(false);
        setSearchErrorMessage("");
        setInitialSearchText(initialSearchText);
    };

    const backendSearch = async (text) => {
        const includes = [];
        const results = await Search(context.activePlant.id, text, includes);
        if (!results.length) setSearchMessage("No results found.");
        setSearchResults(results);
    };

    const localSearch = (keyword) => {
        let results = [];
        searchStructure.forEach((item) => {
            if (item.keys.includes(keyword)) {
                results = results.concat(item.matchedRoutes);
                return;
            }
            item.childRoutes.forEach((childItem) => {
                if (childItem.keys.includes(keyword)) {
                    results = results.concat(childItem.matchedRoutes);
                }
            });
        });
        setLocalSearchResults(results);
    };

    const linkClicked = () => setVisibility(false);

    const triggerSearch = () => {
        setLoadingPrimary(true);
        setSearchResults([]);
        setLocalSearchResults([]);
        if (!initialSearchText.length) {
            setSearchErrorMessage("Please enter text in search field.");
            return;
        }
        const text = initialSearchText.trim().toLowerCase();
        localSearch(text);
        backendSearch(text);
        setLoadingPrimary(false);
    };

    const showResults = (results) => {
        if (!results.length) return "0 Entities Found";
        return loadingPrimary ? (
            <>
                <Spinner />
            </>
        ) : (
            <>
                <p> {results.length} Entities Found</p>
                {results.map((result) => (
                    <div className="card" key={result.id}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-11">
                                    <Link
                                        className="card-title"
                                        to={
                                            "../" +
                                            result.entity_type +
                                            "/" +
                                            result.entity_id
                                        }
                                        onClick={linkClicked}
                                    >
                                        {result.value}
                                    </Link>
                                </div>
                                <div className="col-1">
                                    <Link
                                        target="_blank"
                                        className="card-title"
                                        to={
                                            "../" +
                                            result.entity_type +
                                            "/" +
                                            result.entity_id
                                        }
                                    >
                                        <i className="fa fa-external-link-alt"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </>
        );
    };

    const showLocalSearchResults = (results) => {
        if (!results.length) return "0 Actions Found";
        return (
            <>
                <p> {results.length} Actions Found</p>
                {results.map((result) => (
                    <div className="card" key={result.name}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-11">
                                    <Link
                                        className="card-title"
                                        to={result.route}
                                        onClick={linkClicked}
                                    >
                                        {result.name}
                                    </Link>
                                </div>
                                <div className="col-1">
                                    <Link
                                        target="_blank"
                                        className="card-title"
                                        to={result.route}
                                    >
                                        <i className="fa fa-external-link-alt"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </>
        );
    };

    return (
        <div>
            <Modal
                show={visibility}
                onHide={closeModal}
                keyboard={false}
                centered={true}
                dialogClassName="modal-xl searchModal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Search Result</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="searchBody">
                        <div className="input-group mb-3">
                            <input
                                type="text"
                                name="search"
                                placeholder="Search"
                                className="form-control"
                                value={initialSearchText}
                                onKeyUp={handleKeyUp}
                                onChange={handleInputChange}
                            />
                            <div className="input-group-append">
                                <button
                                    className="btn btn-primary"
                                    type="button"
                                    id="button-addon2"
                                    onClick={triggerSearch}
                                >
                                    Search
                                </button>
                            </div>
                        </div>
                        {searchErrorMessage.length ? (
                            searchErrorMessage
                        ) : (
                            <div
                                style={{
                                    maxHeight: "400px",
                                    overflowY: "auto",
                                }}
                            >
                                {showResults(searchResults)}
                                <hr />
                                {showLocalSearchResults(localSearchResults)}
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default SearchModal;
